module.exports = __WEBPACK_EXTERNAL_MODULE_150__;


//////////////////
// WEBPACK FOOTER
// external {"root":"numbro","commonjs2":"numbro","commonjs":"numbro","amd":"numbro"}
// module id = 150
// module chunks = 0